import React, { memo } from 'react';
import { Row, Col, Spin, theme } from 'antd';
import MessageBubble from './MessageBubble/MessageBubble';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';

const MessageList = memo(({
    messages,
    loading,
    messageRefs,
    handleReplyClick,
    setSelectedMessage,
    setDrawerVisible
}) => {
    const { isDarkMode } = useTheme();
    const { token } = theme.useToken();

    const loadingSpinnerColor = isDarkMode ? token.colorTextLightSolid : token.colorText;

    return (
        <div style={{ display: 'flex', flexDirection: 'column-reverse', width: '100%' }}>
            {loading && <LoadingSpinner color={loadingSpinnerColor} />}
            <div style={{ width: '100%', order: 1 }}>
                <Row gutter={[0, 16]}>
                    {messages.slice().reverse().map(message => (
                        <Col span={24} key={message.id}>
                            <div className="message-item" data-message-id={message.id}>
                                <MessageBubble
                                    message={message}
                                    onReplyClick={handleReplyClick}
                                    messageRefs={messageRefs}
                                    onMessageSelect={(msg) => {
                                        setSelectedMessage(msg);
                                        setDrawerVisible(true);
                                    }}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
});

const LoadingSpinner = ({ color }) => (
    <Row justify="center" style={{ padding: 20, order: 2 }}>
        <Spin style={{ color }} />
    </Row>
);

export default MessageList;
